import { useMediaQuery } from "react-responsive";
import RenderSteps from "./RenderSteps";
import { GoSidebarExpand, GoSidebarCollapse } from "react-icons/go";
import Sidebar from "../Sidebar";
import { useState } from "react";

export default function AddCourse({ contentKind = "course" }) {
  const isMediumScreenOrLarger = useMediaQuery({ minWidth: 768 });

  const [sidebarIconClicked, setSidebarIconClicked] = useState(false);

  return (
    <>
      {/* Responsive design for small screen */}
      <div className="mb-4 md:hidden">
        {!isMediumScreenOrLarger &&
          (sidebarIconClicked ? (
            <div className="flex">
              <GoSidebarExpand
                size={24}
                fill="#AFB2BF"
                onClick={() => setSidebarIconClicked(!sidebarIconClicked)}
              />
              <Sidebar />
            </div>
          ) : (
            <GoSidebarCollapse
              size={24}
              fill="#AFB2BF"
              onClick={() => setSidebarIconClicked(!sidebarIconClicked)}
            />
          ))}
      </div>

      <div className="w-full flex items-start gap-x-6">
        <div className="flex flex-1 flex-col">
          <h1 className="mb-14 text-3xl font-medium text-richblack-5">
            Add {contentKind === "course" ? "Course" : contentKind === "program" ? "Program" : "Mentorship"}
          </h1>
          <div className="flex-1">
            <RenderSteps contentKind={contentKind} />
          </div>
        </div>
        <div className="border sticky top-10 hidden xl:block max-w-[400px] flex-1 bg-richblack-800 p-6 border-richblack-700 rounded-md">
          <p className="mb-8 text-lg text-richblack-5">⚡ Course Upload Tips</p>
          <ul className="ml-5 list-item list-disc space-y-4 text-xs text-richblack-5">
            <li>Set the Course Price option or make it free.</li>
            <li>Standard size for the course thumbnail is 1024x576.</li>
            <li>Video section controls the course overview video.</li>
            <li>Course Builder is where you create & organize a course.</li>
            <li>
              Add Topics in the Course Builder section to create your own
              lessons.
            </li>
            <li>
              Information from the Additional Data section shows up on the
              course single page.
            </li>
            <li>
              Make Sure to add the duration of the video in seconds to get the
              accurate info on your course.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
